export default __webpack_public_path__ + "static/media/contactus.558d6e62.png";